import React, {useEffect, useState} from 'react';
import {Button, Form, Input, message} from "antd";
import './index.css'
import {updateUsername} from "../../../api/user";
import { useDispatch } from 'react-redux';
import {setAuthId} from "../../../store/modules/user";
//设置用户名
const SettingUsernameApp =(props)=>{
    //父组件传输
    const {handleOk,handleCloseModel} = props
    const dispatch = useDispatch()
    //form组件
    const [form] = Form.useForm();
    const onFinish = (values) => {
        updateUsername(values).then(res=>{
            if(res.code === 200){
                message.success('修改成功');
                dispatch(setAuthId(res.data['auth-id']))
                handleOk()
            }
        })
    };
    //校验失败
    const onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };
    //重置内容
    const formReset = ()=>{
        form.resetFields()
    }
    return (
        <div className="SettingUsernameApp">
            <Form onFinish={onFinish} onFinishFailed={onFinishFailed} form={form}>
                <div className='fL'>设置新用户名</div>
                <div>
                    <Form.Item
                        label=""
                        name="new_username"
                        rules={[
                            {
                                required: true,
                                message: '请输入用户名',
                            },{
                                pattern: new RegExp(/^[A-Za-z0-9\_\-]{4,32}$/, 'g'),
                                message: '请输入4位以上,32以下字符的用户名'
                            }
                        ]}
                    >
                        <Input placeholder="长度4-32 仅支持 _ 0-9 a-z A-Z" size="large"/>
                    </Form.Item>
                </div>
                <Form.Item>
                    <div className='textCenter'>
                        <Button className='selfBtn' htmlType="submit">
                            提交
                        </Button>
                        <Button className='selfBtn btn2' onClick={handleCloseModel}>
                            取消
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        </div>
    )
}

export default SettingUsernameApp
